module.exports = __webpack_public_path__ + "static/img/图层17.08c9ba2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cardSolution/图层17.png
// module id = mz6h
// module chunks = 0